import React from "react";
import {
    Dialog,
    DialogTitle,
    DialogTitleProps,
    DialogContent,
    DialogActions,
    IconButton,
    IconButtonProps,
    useTheme,
    Typography,
    Button,
} from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import { useTranslation } from "react-i18next";
import * as Styles from "pages/employee/users/userDetails/modals/outOfService.styles.modal";
import * as userService from "services/user-service";
import { UserDto } from "services/user-service";
import { useParams } from "react-router-dom";
import { updateUser } from "services/AuthenticationService";

interface IProps {
    open: boolean;
    onClose: (event: any, reason: string) => void;
    handleClose: () => void;
    user: UserDto;
    updateUser: (value: UserDto) => void;
    // updateCertificate: Dispatch<CertificateWithDetails>;
    // dateCertificate?: Date
}

const OutOfServiceModal = (props: IProps) => {
    const { open, onClose, handleClose, updateUser, user } = props;
    const { t } = useTranslation();
    const theme = useTheme();
    const { userId } = useParams();

    const handleSubmit = (): void => {
        if (userId) {
            userService.setUserOutOfService(userId).then(() => {
                updateUser({ ...user, actief: false });
                handleClose();
            });
        }
    };

    // const handleSubmit = (): void => {
    //     if (date !== null && date !== undefined && certificateId !== undefined) {
    //         certificateService.setOutOfService(certificateId, date).then((res) => {
    //             updateCertificate(res);
    //             handleClose();
    //         });
    //     }
    // }

    const statusDialogTitle: DialogTitleProps = {
        sx: Styles.statusDialogTitle(theme),
    };

    const closeDialogIconButton: IconButtonProps = {
        sx: Styles.closeDialogIconButton(theme),
    };

    return (
        <Dialog
            fullWidth
            open={open}
            onClose={onClose}
            aria-labelledby="out-of-service-modal"
        >
            <DialogTitle {...statusDialogTitle}>
                {t("certificateWithDetail.OOS.title")}
                <IconButton
                    {...closeDialogIconButton}
                    aria-label="close"
                    onClick={handleClose}
                >
                    <CloseIcon />
                </IconButton>
            </DialogTitle>
            <DialogContent dividers>
                <Typography variant="body2" gutterBottom>
                    {t("users.OOS.info")}
                </Typography>
            </DialogContent>
            <DialogActions>
                <Button onClick={handleClose} variant="contained">
                    {t("requestWithDetail.cancelButton")}
                </Button>
                <Button
                    variant="contained"
                    color="success"
                    autoFocus
                    onClick={handleSubmit}
                    disabled={false}
                >
                    {t("requestWithDetail.confirmButton")}
                </Button>
            </DialogActions>
        </Dialog>
    );
};

export default OutOfServiceModal;
